import script from "./ComparisonsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ComparisonsView.vue?vue&type=script&setup=true&lang=js"

import "./ComparisonsView.vue?vue&type=style&index=0&id=63c90378&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c90378"]])

export default __exports__